module.exports = __webpack_public_path__ + "img/usernoavatar.d040ce81.png";